import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarrierApproval = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "carrierApproval",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17254",
		"data-name": "Group 17254",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12807",
				"data-name": "Path 12807",
				d: "M4,18V9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12808",
				"data-name": "Path 12808",
				d: "M20,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12809",
				"data-name": "Path 12809",
				d: "M8,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12810",
				"data-name": "Path 12810",
				d: "M12,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12811",
				"data-name": "Path 12811",
				d: "M16,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12812",
				"data-name": "Path 12812",
				d: "M12,6.275a.124.124,0,0,0-.124.125.125.125,0,0,0,.25,0A.127.127,0,0,0,12,6.275",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12813",
				"data-name": "Path 12813",
				d: "M21.5,9H2.5V6.361L12,3l9.5,3.361Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12814",
				"data-name": "Path 12814",
				d: "M21,18H3L2,19v2H22V19Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12815",
		"data-name": "Path 12815",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgCarrierApproval;
